import { render, staticRenderFns } from "./DoctorIntroduction.vue?vue&type=template&id=1eceed0f&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./DoctorIntroduction.vue?vue&type=script&lang=js"
export * from "./DoctorIntroduction.vue?vue&type=script&lang=js"
import style0 from "./DoctorIntroduction.vue?vue&type=style&index=0&id=1eceed0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eceed0f",
  null
  
)

export default component.exports